import { Button } from 'antd'
import styled from 'styled-components'

const equipColor = {
  primary: '#131a5e',
  secondary: '#FF9D0B',
}

export const AntButtonStyled = styled(Button)`
  &.withHover-primary:hover {
    background-color: ${equipColor.primary};
    color: white !important;
  }
  &.withHover-secondary:hover {
    background-color: ${equipColor.secondary};
    color: white !important;
  }

  &.degraded {
    background: linear-gradient(90deg, #fdd96d 0%, #f08732 100%);
    color: #030852;
    font-weight: 700;
    font-size: 1.125rem;
    padding: 0.8rem 2rem;
    border: none;
    border-radius: 1.5rem;
    cursor: pointer;
  }
  &.degraded:hover {
    background: linear-gradient(90deg, #fdd96d 0%, #f08732 100%) !important;
    transform: scale(1.1);
  }
`
